// @flow
import React from 'react';

import Select from '../../../Select';
import Text from '../Text';

type OPTION_TYPE = {
  value: any
};

export type SelectCellPropTypes = {
  value: string,
  original: Object,
  editable?: boolean,
  onChange?: Function,
  options?: Array<OPTION_TYPE>,
};

type SelectStateTypes = {
  isEditing?: boolean,
  editingValue: string | number,
};

class SelectCell extends React.Component<SelectCellPropTypes, SelectStateTypes> {
  constructor(props: SelectCellPropTypes) {
    super(props);

    this.state = {
      editingValue: props.value,
      isEditing: false,
    };
  }

  _onKeyDown(event: KeyboardEvent) {
    const { value, onChange, original } = this.props;
    switch (event.key) {
      case 'Escape': {
        event.preventDefault();
        this.setState({
          isEditing: false,
          editingValue: value,
        });
        break;
      }
      case 'Enter': {
        event.preventDefault();

        if (onChange) {
          // $FlowFixMe
          onChange(original, event.target.value);
        }

        this.setState({
          isEditing: false,
        });

        break;
      }
      default: {
        break;
      }
    }
  }

  _onChange(value: Object) {
    const { original, onChange } = this.props;
    if (onChange) {
      onChange(original, value);
    }

    this.setState({
      isEditing: false,
    });
  }

  _onBlur() {
    const { value } = this.props;
    this.setState({
      isEditing: false,
      editingValue: value,
    });
  }

  render() {
    const {
      value,
      editable = false,
      options,
      original,
    } = this.props;
    const { editingValue, isEditing } = this.state;

    if (editable) {
      return (
        <Select
          options={options}
          onChange={this._onChange.bind(this)}
          value={editingValue}
          size="small"
        />
      );
    }

    return (
      <Text
        value={value}
        original={original}
        editable={false}
      />
    );
  }
}

export default SelectCell;



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Cells/Select/index.jsx